import React from 'react'
import hipsterHeadphones from '../../../../assets/hipster-headphones.webp'
import keyboard from '../../../../assets/keyboard.webp'
import headphones from '../../../../assets/headphones.webp'
import darkCamera from '../../../../assets/dark-camera.webp'
import mouse from '../../../../assets/mouse.webp'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock } from '@fortawesome/free-solid-svg-icons'

const arr = [
  {img: darkCamera, name: "Camera", sold: 334},
  {img: keyboard, name: "Keyboard", sold: 582},
  {img: hipsterHeadphones, name: "Headphones-2", sold: 760},
  {img: headphones, name: "Heaphones", sold: 549},
  {img: mouse, name: "Mouse", sold: 218},
]

const BestSellers = () => {
  return (
    <div className='w-100 d-flex flex-wrap justify-content-center p-4 h-100 rounded' style={{boxShadow: "0 0 32px 2px turquoise"}}>
      {arr.map(x => <div style={{
        background: "turquoise", 
        marginTop: `-${Math.ceil(x.sold/5 )}`,
        width: "260px",
        flexGrow: "1",
        maxWidth: "320px"
      }} className='m-2 p-4 text-light rounded'>
        <p className='fs-2'>{x.name}</p>
        <p>{x.sold} units</p>
        <div style={{padding:"1px"}} className="bg-light w-100 mb-3"></div>
        <div className='d-flex justify-content-between align-items-center'>
        <FontAwesomeIcon className='fs-2' icon={faClock} /> 
        <p>March 17 2.15 am</p>

      </div>
      </div>)}
    </div>
  )
}

export default BestSellers